// extracted by mini-css-extract-plugin
export default {"color-mischka":"#e0e1e7","colorMischka":"#e0e1e7","sidebar":"KjBby","inner":"QxN3X","title":"_3yfXW","horizontal":"_25-lD","product":"_30xDB","cardImage":"etz5e","cardLink":"_1aJgA"};